export const CSV_ROW_LIMIT = 1000;

export const REQUEST_STATUS = {
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED'
} as const;

export const ITEM_STATUS = {
	PENDING: 'PENDING',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE'
} as const;

export const CSV_HEADERS = {
	EMAIL: 'email id',
	ACTION: 'action',
	USERNAME: 'username',
	PHONE: 'phone no',
	DEPARTMENT: 'department',
	MANAGER: 'manager',
	DESIGNATION: 'designation',
	TEAM: 'team',
	ROLE_NAME: 'role name',
	PERMISSIONS: 'permissions',
	PERMISSION_SET: 'permission set',
	EXPIRE_AFTER_SEC: 'expire after sec',
	IS_MASKED: 'is masked'
} as const;

export const CSV_ACTIONS = {
	CREATE: 'create',
	DELETE: 'delete'
} as const;

export const FORM_FIELD_KEYS = {
	DESCRIPTION: 'description',
	CSV_FILE: 'csvFile'
} as const;

export const FORM_FIELD_LABELS = {
	DESCRIPTION: 'Description'
} as const;

export const TABLE_COLUMNS = {
	CSV_PREVIEW: [
		'Idx',
		'Email',
		'Action',
		'Username',
		'Phone',
		'Department',
		'Manager',
		'Designation',
		'Team',
		'Role',
		'Permissions',
		'Permission Set',
		'Expire After (Sec)',
		'Is Masked'
	]
} as const;

export const API_ENDPOINTS = {
	LIST_REQUESTS: '/dashboard/forward/settingsV2-bulkUserCsv-listBulkUserRequests',
	CREATE_REQUEST: '/dashboard/forward/settingsV2-bulkUserCsv-createBulkUserRequest',
	CHECK_STATUS: '/dashboard/forward/settingsV2-bulkUserCsv-checkBulkUserRequestStatus'
} as const;

export const PAGINATION = {
	DEFAULT_PAGE_SIZE: 20,
	STATUS_PAGE_SIZE: 50,
	CSV_PREVIEW_LIMIT: 100
} as const;

export const PLACEHOLDERS = {
	DESCRIPTION: 'Provide a description for this bulk user request',
	CSV_FILE: `Upload CSV (max ${CSV_ROW_LIMIT} rows)`
};

export const PERMISSION_TYPES = {
	SINGLE_PERMISSION: 'singlePermission',
	PERMISSION_SET: 'permissionSet'
} as const;

export const FORWARD_ROUTES = {
	LIST_REQUESTS: '/dashboard/bulkUserCsv/listBulkUserRequests',
	CHECK_STATUS: '/dashboard/bulkUserCsv/checkBulkUserRequestStatus',
	CREATE_REQUEST: '/dashboard/bulkUserCsv/createBulkUserRequest'
} as const;

export const ENTITIES = {
	BULK_USER_CSV: 'BULK_USER_CSV',
	BULK_USER_CSV_STATUS: 'BULK_USER_CSV_STATUS'
} as const;

export const STATUS_COLORS = {
	[REQUEST_STATUS.COMPLETED]: '#28a745',
	[REQUEST_STATUS.FAILED]: '#dc3545',
	[REQUEST_STATUS.IN_PROGRESS]: '#ffc107',
	[ITEM_STATUS.SUCCESS]: '#28a745',
	[ITEM_STATUS.FAILURE]: '#dc3545',
	[ITEM_STATUS.PENDING]: '#ffc107',
	DEFAULT: '#6c757d'
} as const;

export const LIST_COL_NAMES = {
	REQUESTER_EMAIL: 'requesterEmail',
	DESCRIPTION: 'description',
	STATUS: 'status',
	CREATED_AT: 'createdAt',
	TOTAL_ROWS: 'totalRows',
	PROCESSED_ROWS: 'processedRows',
	SUCCESS_COUNT: 'successCount',
	FAILURE_COUNT: 'failureCount'
} as const;

export const STATUS_COL_NAMES = {
	USER_EMAIL: 'userEmail',
	ACTION: 'action',
	STATUS: 'status',
	PROCESSED_AT: 'processedAt',
	REMARK: 'remark'
} as const;

export const MESSAGES = {
	UPLOAD_SUCCESS: (count: number) => `Successfully parsed ${count} rows from CSV`,
	UPLOAD_ERROR: 'Failed to parse CSV file',
	CREATE_SUCCESS: 'Bulk user request created successfully',
	CREATE_ERROR: 'Failed to create bulk user request',
	FETCH_ERROR: 'Error fetching requests',
	STATUS_ERROR: 'Error fetching status details',
	VALIDATION: {
		DESCRIPTION_REQUIRED: 'Please enter a description',
		CSV_FILE_REQUIRED: 'Please upload a valid CSV file',
		CSV_EMPTY: 'CSV file is empty',
		CSV_NO_DATA: 'No valid data rows found in CSV',
		CSV_ROW_LIMIT_EXCEEDED: `CSV contains more than ${CSV_ROW_LIMIT} rows. Please reduce the number of rows.`,
		CSV_INVALID_HEADERS:
			'CSV headers do not match expected format: Email ID | Action | Username | Phone No | Department | Manager | Designation | Team | Role Name | Permissions | Permission Set | Expire After Sec | Is Masked',
		FILE_READ_ERROR: 'Failed to read file'
	},
	INVALID_ROW_REASONS: {
		MISSING_REQUIRED_FIELDS: 'Missing required fields',
		INVALID_EMAIL: 'Invalid email',
		INVALID_PHONE: 'Invalid phone',
		INVALID_ACTION: 'Invalid action'
	}
} as const;
